import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import { DataGrid, ColDef, ValueFormatterParams, ValueGetterParams } from '@material-ui/data-grid';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import moment from 'moment';
import React, { useContext, useEffect } from 'react';

import { ctx, IStore } from 'store';
import { moodColors } from 'styles';

import { useStyles } from './styles';

const Logs: React.FC = () => {
  const {
    teams: { currentTeam },
    diagnostics: { diagnostics },
  } = useContext(ctx.store);
  const actions = useContext(ctx.actions);
  const classes = useStyles();

  useEffect(() => {
    const fetch = async () => {
      const team = currentTeam.teamId ? currentTeam.teamId : currentTeam.tenantId;
      const platform = currentTeam.teamId ? 'slack' : 'microsoft';
      await ((actions.misc.setLoading(true) as unknown) as Promise<IStore>);
      await ((actions.diagnostics.getDiagnostics(team, platform) as unknown) as Promise<IStore>);
      await ((actions.misc.setLoading(false) as unknown) as Promise<IStore>);
    };

    fetch();
  }, [currentTeam]);

  const columns: ColDef[] = [
    {
      flex: 0.8,
      field: 'involvedChannel',
      headerName: 'Channel',
      sortable: true,
      valueGetter: (params: ValueGetterParams) => {
        if (currentTeam.teamId) {
          return `#${currentTeam.channels.find((ch: any) => ch.channelId === params.value).name}`;
        } else {
          return `#${currentTeam.msChannels.find((ch: any) => ch.channelId === params.value).name}`;
        }
      },
    },
    {
      flex: 1.2,
      field: 'membersInvolved',
      headerName: 'Members',
      sortable: false,
      valueGetter: (params: ValueGetterParams) => {
        if (currentTeam.teamId) {
          if (params.value) {
            return `@${
              currentTeam.members.find((mem: any) => mem.memberId === (params.value as any)[0])
                .profile.displayName
            } ${
              (params.value as any).length > 1 ? `and ${(params.value as any).length - 1} more` : ''
            }`;
          } else {
            return 'No available';
          }
        } else {
          if (params.value) {
            return `@${
              currentTeam.msMembers.find((mem: any) => mem.memberId === (params.value as any)[0])
                .profile.displayName
            } ${
              (params.value as any).length > 1 ? `and ${(params.value as any).length - 1} more` : ''
            }`;
          } else {
            return 'No available';
          }
        }
      },
    },
    {
      flex: 0.4,
      field: 'notification',
      headerName: 'Notified',
      renderCell: (params: ValueFormatterParams) => {
        if (params.data.notification) {
          return <CheckCircleOutlineIcon style={{ color: moodColors.positive }} />;
        } else {
          return <HighlightOffIcon style={{ color: moodColors.negative }} />;
        }
      },
    },
    {
      flex: 0.4,
      field: 'sentiment',
      headerName: 'Sentiment',
      // eslint-disable-next-line react/display-name
      renderCell: (params: ValueFormatterParams) => (
        <Paper
          className={classes.paperMoodColor}
          elevation={0}
          style={{
            background: `${
              params.data.sentiment === 'positive' ? moodColors.positive : moodColors.negative
            }`,
          }}
        />
      ),
    },
    {
      flex: 0.8,
      field: 'ts',
      headerName: 'Date',
      sortable: true,
      valueGetter: (params: any) => moment.unix(params.value).format('LLL'),
    },
    {
      flex: 0.5,
      field: 'id',
      headerName: 'Go To',
      // eslint-disable-next-line react/display-name
      renderCell: (params: ValueFormatterParams) => (
        <strong>
          <Button
            variant="contained"
            color="primary"
            size="small"
            href={
              currentTeam.teamId
                ? `https://${currentTeam.domain}.slack.com/archives/${
                    params.data.involvedChannel
                  }/p${params.data.ts.split('.').join('')}`
                : `https://teams.microsoft.com/l/message/${params.data.involvedChannel}/${params.data.messageId}`
            }
            target="_blank"
          >
            {currentTeam.teamId ? 'Open in Slack' : 'Open in Ms Teams'}
          </Button>
        </strong>
      ),
    },
  ];

  return (
    <Grid container item xs={12} className={classes.root}>
      <Typography component="h1" variant="h5">
        Logs
      </Typography>
      <DataGrid
        className={classes.listStyle}
        rows={diagnostics}
        columns={columns}
        hideFooterSelectedRowCount={true}
      />
    </Grid>
  );
};

Logs.displayName = 'Logs';

export { Logs };
